'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { useForm } from 'react-hook-form';
import lottieFile from '../../../Assets/contact-lootie-for-protfolio.json';
import { toast } from 'react-toastify';

const Lottie = dynamic(() => import('react-lottie-player'), { ssr: false });

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async data => {
    try {
      const response = await fetch(
        'https://visitorportfolio.vercel.app/api/message/post-messages',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            senderName: data.name,
            message: data.message,
          }),
        }
      );

      if (response.ok) {
        toast.success('Message sent successfully!');
        reset(); // Reset the form after successful submission
      } else {
        toast.error('Failed to send the message. Please try again later.');
      }
    } catch (error) {
      console.error(error);
      toast.error('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <div
      id='Contact'
      className='flex flex-col md:flex-row justify-center items-center min-h-screen text-white p-6 bg-gradient-to-b from-purple-900 via-blue-800 to-gray-900 backdrop-blur-md'
    >
      {/* Form Section */}
      <div className='md:w-1/2 w-full max-w-md'>
        <h1 className='text-6xl font-bold mb-6'>
          Let’s <span className='text-yellow-400'>talk</span>
        </h1>
        <p className='mb-6 text-gray-400'>
          I am waiting for your message, just drop a message here if you want.
        </p>
        <form onSubmit={handleSubmit(onSubmit)} className='space-y-4'>
          {/* Name Field */}
          <div>
            <label htmlFor='name' className='block text-sm font-medium mb-2'>
              Your Name
            </label>
            <input
              id='name'
              {...register('name', { required: 'Name is required' })}
              type='text'
              placeholder='Enter your name'
              className='w-full px-4 py-2 rounded-md bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500'
            />
            {errors.name && (
              <p className='text-red-500 text-sm mt-1'>{errors.name.message}</p>
            )}
          </div>
          {/* Message Field */}
          <div>
            <label htmlFor='message' className='block text-sm font-medium mb-2'>
              Your Message
            </label>
            <textarea
              id='message'
              {...register('message', { required: 'Message is required' })}
              placeholder='Type your message here...'
              className='w-full px-4 py-2 h-28 rounded-md bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500'
            />
            {errors.message && (
              <p className='text-red-500 text-sm mt-1'>
                {errors.message.message}
              </p>
            )}
          </div>
          {/* Submit Button */}
          <button
            type='submit'
            className='w-full py-2 px-4 bg-yellow-500 text-gray-900 font-semibold rounded-md hover:bg-yellow-400 transition duration-300'
          >
            SEND MESSAGE
          </button>
        </form>
      </div>

      {/* Lottie Animation Section */}
      <div className='md:w-1/2 w-full flex justify-end mt-10 md:mt-0'>
        <div className='max-w-xl'>
          <Lottie loop animationData={lottieFile} play />
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
